import { styled } from 'styled-components'

const OfrFormContainer = styled.div`
  position: relative;
  margin-bottom: 16px;
  min-height: 36px;
`

export default OfrFormContainer
